<div class="container">
  <div class="hidden md:block md:mb-6">
    <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
  </div>
  <div class="page-tab-menu">
    <ul class="page-tab-menu__wrapper scroll-invisible">
      <li class="page-tab-menu__item"><a [href]="'/o-companii'" class="page-tab-menu__link active">О компании</a></li>
      <li class="page-tab-menu__item"><a [href]="'/press-centr'" class="page-tab-menu__link">Пресс-центр</a></li>
      <li class="page-tab-menu__item">
        <a [href]="'/konsalting-i-analitika'" class="page-tab-menu__link">Консалтинг и аналитика</a>
      </li>
      <li class="page-tab-menu__item"><a [href]="'/vacancies'" class="page-tab-menu__link">Вакансии</a></li>
      <li class="page-tab-menu__item"><a [href]="'/otzyvy'" class="page-tab-menu__link">Отзывы</a></li>
      <li class="page-tab-menu__item"><a [href]="'/kontakty'" class="page-tab-menu__link">Контакты</a></li>
    </ul>
  </div>
  <div class="company-intro">
    <div class="company-intro__left">
      <h1 class="text-2xl md:text-5xl font-bold mb-4">Добро пожаловать в NDV</h1>
      <p class="text-xs md:text-base">
        На протяжении 25 лет мы работаем над тем, чтобы сделать покупку недвижимости для вас максимально удобной и доступной
      </p>
    </div>
    <div class="company-intro__view">
      <swiper-container class="company-intro__view-slider" #layoutSwiper init="false">
        @for (img of introImages; track $index) {
          <swiper-slide class="company-intro__view-slide">
            <img class="company-intro__view-slide-img" [src]="img" alt="#" />
          </swiper-slide>
        }
      </swiper-container>
      <button class="company-intro__view-icon" (click)="openVideo()">
        <app-ui-icon [name]="'icon-play-circle'" [width]="47"></app-ui-icon>
      </button>
      <div class="company-intro__view-pagination">
        <div #pagination></div>
      </div>
    </div>
  </div>
  <div class="company-features">
    <swiper-container class="slider-only-mobile company-features__slider" #layoutFeatures init="false">
      @for (item of features; track $index) {
        <swiper-slide class="swiper-slide company-features__slide">
          <div class="company-feature">
            <div class="company-feature__title">{{ item.title }}</div>
            <div class="company-feature__desc">{{ item.desc }}</div>
          </div>
        </swiper-slide>
      }
    </swiper-container>
    <div class="md:hidden">
      <div class="slider-pagination-wrapper">
        <div #featuresPagination></div>
      </div>
    </div>
  </div>
  <div class="company-desc">
    <p class="company-desc__text" [ngClass]="{ active: isExpanded[0] }">
      Ведущее агентство недвижимости, лидер по реализации новостроек в Москве, Подмосковье и регионах России. Компания работает по принципу
      «супермаркета», предлагая покупателям все виды коммерческой и жилой недвижимости, а также большой выбор услуг. Отдельное направление
      деятельности связано с работой с застройщиками, банками, архитекторами и проектировщиками.  Наши компетенции и опыт позволяют
      подключиться на любом этапе реализации недвижимости и кратно увеличить число сделок и рентабельность проекта. Мы готовы разработать
      успешную стратегию продаж, включая эффективные антикризисные методы. Наши сотрудники являются настоящими экспертами рынка
      недвижимости, для реализации новых проектов мы привлекаем лучших профессионалов в своем деле. Мы уделяем большое внимание кадровой
      политике и собираем команду настоящих единомышленников. За 25 лет существования компания неоднократно признавалась лучшей на рынке
      недвижимости, как среди покупателей, так и в профессиональных кругах.
    </p>
    <button class="company-desc__btn" (click)="toggleText(0)">
      Читать больше
      <app-ui-icon name="icon-arrow-right-small" width="10" height="14"></app-ui-icon>
    </button>
  </div>
  <div class="company-system">
    <div class="company-header">
      <h2 class="col-start-2 text-base md:text-4xl font-bold mb-0">Экосистема NDV</h2>
    </div>
    <div class="company-system__grid">
      @for (sys of companySystems; track $index) {
        <div class="company-system__item">
          <div class="company-system__item-title">{{ sys.title }}</div>
          <div class="company-system__item-img">
            <img [src]="sys.img" alt="#" />
          </div>
          <div class="company-system__item-text">{{ sys.text }}</div>
          <div class="company-system__item-arrow"></div>
        </div>
      }
    </div>
  </div>
  <div class="company-partners">
    <div class="company-header">
      <h2 class="col-start-2 text-base md:text-4xl font-bold mb-0">Партнеры</h2>
      <div class="flex">
        <a class="company-header__more" href="#">все партнеры</a>
      </div>
    </div>
    <div class="company-partners__grid">
      <div class="company-partners__desc">
        <p>
          Компания объединяет свыше 1 500 партнеров, включая застройщиков и банки. Представители этих партнеров могут предоставлять свои
          услуги непосредственно в офисе NDV.
        </p>
        <p>
          Регулярно проводятся партнерские дни, а также организуются экскурсии для потенциальных клиентов по новостройкам и загородным
          объектам
        </p>
      </div>
      <div class="company-partners__items">
        <swiper-container class="slider-only-mobile company-partners__slider" #layoutPartners init="false">
          @for (partner of partners; track $index) {
            <swiper-slide class="swiper-slide company-partners__slide">
              <div class="company-partners__item">
                <img
                  class="company-partners__thumb"
                  [src]="partner.img"
                  [srcset]="partner.img + ' 1x, ' + partner.img2x + ' 2x'"
                  [alt]="partner.alt"
                />
              </div>
            </swiper-slide>
          }
        </swiper-container>
        <div class="md:hidden">
          <div class="slider-pagination-wrapper">
            <div #partnersPagination></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="company-achievements">
    <div class="company-header">
      <h2 class="col-start-2 text-base md:text-4xl font-bold mb-0">Награды</h2>
      <div class="flex">
        <a class="company-header__more" href="#">все награды</a>
      </div>
    </div>
    <div class="company-achievements__items">
      <swiper-container class="slider-only-mobile company-achievements__slider" #layoutAchievement init="false">
        @for (a of achievements; track $index) {
          <swiper-slide class="swiper-slide company-achievements__slide">
            <div class="company-achievements__item">
              <div class="company-achievements__item-icon">
                <img class="company-achievements__thumb" [src]="a.img" [srcset]="a.img + ' 1x, ' + a.img2x + ' 2x'" [alt]="a.title" />
              </div>
              <div class="company-achievements__item-title">{{ a.title }}</div>
              <div class="company-achievements__item-text">{{ a.text }}</div>
            </div>
          </swiper-slide>
        }
      </swiper-container>
      <div class="md:hidden">
        <div class="slider-pagination-wrapper">
          <div #achievementPagination></div>
        </div>
      </div>
    </div>
  </div>
  <div class="company-search">
    <div class="company-search__left">
      <h2 class="company-search__title font-bold mb-3 md:mb-5 text-2xl md:text-3xl">
        Найти недвижимость <br />
        на ndv.ru
      </h2>
      <p class="company-search__desc text-xs md:text-base mb-5 md:mb-10">
        Выбирайте из надежной базы объектов. Специалист по недвижимости организует сделку "под ключ" для вас.
      </p>
      <a href="/kupit-kvartiru-all" class="company-search__btn">Искать недвижимость</a>
    </div>
    <div class="company-search__img">
      <img
        class="company-search__img-object"
        [src]="'assets/images/company/search.png'"
        [srcset]="'assets/images/company/search.png 1x, assets/images/company/search@2x.png 2x'"
        [alt]="'#'"
      />
    </div>
  </div>
</div>

<app-modal-single [classes]="'ui-modal--transparent ui-modal--container'" [active]="isOpenVideo" (closeModal)="closeModals()">
  <video class="w-full" #video controls="controls" preload="none">
    <source [src]="'#'" type="video/mp4" />
  </video>
</app-modal-single>
